import inputmask from "inputmask";

export const checkPhone = (inputLabel) => {
  const input = inputLabel.querySelector(".input-container__input")
  input.value = input.value.slice(1)

  inputmask('+7 999 999-99-99').mask(input)
  const acceptPhone = () => {
    const checkPhone = input.value.replace('_', '').length === 16
    checkPhone ? inputLabel.classList.remove('input-container--error') : inputLabel.classList.add('input-container--error')
    return checkPhone
  }

  return {
    acceptPhone
  }
  
}
